import { Address } from "viem";

export const COINGECKO_NATIVE_TOKEN_ADDRESS: Address = "0x0000000000000000000000000000000000001010";
